import { html } from 'lit-html';
import templateProject from './template-project';

const template = (data) => html`
<div class="project-situation-map-svg-container" data-loading="${data.state.loadingProjects || data.state.loadingViews}" data-projects-loaded="${data.isProjectsLoaded()}" style="background-image: url('${data.props.backgroundImageSrc}');">
	${(data => {
		if (data.state.error) {
			return html`<div class="project-situation-map-message project-situation-map-message-type-error"><p>${data.state.error.message}</p></div>`;
		}
		if (data.projects.length > 0) {
			return html`
			<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 ${data.props.mapWidth} ${data.props.mapHeight}" width="${data.props.mapWidth}" height="${data.props.mapHeight}" xml:space="preserve">
				${data.projects.map((project) => html`${templateProject(project, data)}`)}
			</svg>
			`;
		}
	})(data)}
</div>`;

export default template;